import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=670a1e33"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"
import style0 from "./CommentItem.vue?vue&type=style&index=0&id=670a1e33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports